import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm1.488 2.43a.75.75 0 1 0-.976 1.14l6.35 5.442a1.75 1.75 0 0 0 2.277 0l6.35-5.443a.75.75 0 1 0-.977-1.138l-6.35 5.442a.25.25 0 0 1-.325 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }